class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
    // 新增：手机端内联筛选器事件监听
    this.setupMobileInlineFilters();
  }

  // 新增：设置手机端内联筛选器事件
  setupMobileInlineFilters() {
    // 监听筛选器选择变化
    const inlineSelects = document.querySelectorAll('.mobile-facets-inline__select');
    inlineSelects.forEach(select => {
      // 检查是否只有一个有效选项（除了默认的空选项）
      this.autoSelectSingleOption(select);
      
      select.addEventListener('change', (event) => {
        this.onMobileInlineFilterChange(event);
      });
    });

    // 监听价格输入框变化
    const priceInputs = document.querySelectorAll('.mobile-facets-inline__price-input');
    priceInputs.forEach(input => {
      input.addEventListener('input', (event) => {
        this.onMobileInlineFilterChange(event);
      });
    });

    // 监听 Button Group 按钮点击
    const buttonGroupButtons = document.querySelectorAll('.mobile-facets-inline__button');
    buttonGroupButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        this.onMobileInlineButtonClick(event);
      });
    });

    // 监听应用按钮点击
    const applyButton = document.querySelector('.mobile-facets-inline__apply');
    if (applyButton) {
      applyButton.addEventListener('click', (event) => {
        this.onMobileInlineApplyClick(event);
      });
    }

    // 监听激活筛选器按钮点击
    this.setupActiveFacetsButtons();
  }

  // 新增：自动选择单个选项
  autoSelectSingleOption(select) {
    const options = select.querySelectorAll('option');
    const validOptions = Array.from(options).filter(option => 
      option.value !== '' && !option.disabled
    );
    
    // 如果只有一个有效选项且当前没有选中任何值
    if (validOptions.length === 1 && select.value === '') {
      select.value = validOptions[0].value;
      // 触发 change 事件以应用筛选
      select.dispatchEvent(new Event('change'));
    }
  }

  // 新增：设置激活筛选器按钮事件
  setupActiveFacetsButtons() {
    const activeFacetsButtons = document.querySelectorAll('.active-facets__button');
    activeFacetsButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        this.onActiveFacetsButtonClick(event);
      });
    });
  }

  // 新增：处理激活筛选器按钮点击
  onActiveFacetsButtonClick(event) {
    // 获取按钮中的筛选器信息
    const button = event.target.closest('.active-facets__button');
    if (!button) return;

    const buttonText = button.textContent.trim();
    const filterMatch = buttonText.match(/^([^:]+):\s*(.+)$/);
    
    if (filterMatch) {
      const filterLabel = filterMatch[1].trim();
      const filterValue = filterMatch[2].trim();
      
      // 更新对应的内联筛选器
      this.updateInlineFiltersFromActiveFacet(filterLabel, filterValue);
    }
  }

  // 新增：根据激活筛选器更新内联筛选器
  updateInlineFiltersFromActiveFacet(filterLabel, filterValue) {
    // 更新 Select 筛选器
    const inlineSelects = document.querySelectorAll('.mobile-facets-inline__select');
    inlineSelects.forEach(select => {
      const selectLabel = select.closest('.mobile-facets-inline__filter').querySelector('.mobile-facets-inline__label').textContent.trim();
      
      if (selectLabel === filterLabel) {
        // 找到对应的选项并选中
        const options = select.querySelectorAll('option');
        options.forEach(option => {
          if (option.textContent.includes(filterValue)) {
            select.value = option.value;
            select.dispatchEvent(new Event('change'));
          }
        });
      }
    });

    // 更新 Button Group 筛选器
    const buttonGroups = document.querySelectorAll('.mobile-facets-inline__button-group');
    buttonGroups.forEach(buttonGroup => {
      const buttonGroupLabel = buttonGroup.closest('.mobile-facets-inline__filter').querySelector('.mobile-facets-inline__label').textContent.trim();
      
      if (buttonGroupLabel === filterLabel) {
        const buttons = buttonGroup.querySelectorAll('.mobile-facets-inline__button');
        buttons.forEach(button => {
          if (button.textContent.includes(filterValue)) {
            // 更新按钮状态
            this.updateButtonGroupState(button, button.dataset.filterParam);
          }
        });
      }
    });
  }

  // 新增：处理手机端内联筛选器变化
  onMobileInlineFilterChange(event) {
    // 延迟执行，避免频繁请求
    clearTimeout(this.mobileInlineTimeout);
    this.mobileInlineTimeout = setTimeout(() => {
      this.submitMobileInlineFilters();
    }, 300);
  }

  // 新增：处理 Button Group 按钮点击
  onMobileInlineButtonClick(event) {
    event.preventDefault();
    const button = event.target;
    const filterType = button.dataset.filterType;
    const filterParam = button.dataset.filterParam;
    const value = button.dataset.value;

    // 更新按钮状态
    this.updateButtonGroupState(button, filterParam);

    // 立即提交筛选
    this.submitMobileInlineFilters();
  }

  // 新增：更新 Button Group 状态
  updateButtonGroupState(clickedButton, filterParam) {
    const buttonGroup = clickedButton.closest('.mobile-facets-inline__button-group');
    if (!buttonGroup) return;

    const buttons = buttonGroup.querySelectorAll('.mobile-facets-inline__button');
    const clickedValue = clickedButton.dataset.value;

    buttons.forEach(button => {
      const buttonValue = button.dataset.value;
      
      // 移除所有按钮的激活状态
      button.classList.remove('mobile-facets-inline__button--active');
      button.setAttribute('aria-pressed', 'false');

      // 如果点击的是清除按钮，所有按钮都应该是非激活状态
      if (clickedValue === '') {
        return;
      }

      // 如果点击的是具体值，只有该按钮应该是激活状态
      if (buttonValue === clickedValue) {
        button.classList.add('mobile-facets-inline__button--active');
        button.setAttribute('aria-pressed', 'true');
      }
    });
  }

  // 新增：处理手机端内联筛选器应用按钮点击
  onMobileInlineApplyClick(event) {
    event.preventDefault();
    this.submitMobileInlineFilters();
  }

  // 新增：提交手机端内联筛选器
  submitMobileInlineFilters() {
    const formData = new FormData();
    
    // 收集所有筛选器值
    const inlineSelects = document.querySelectorAll('.mobile-facets-inline__select');
    inlineSelects.forEach(select => {
      if (select.value) {
        formData.append(select.name, select.value);
      }
    });

    // 收集 Button Group 值
    const buttonGroups = document.querySelectorAll('.mobile-facets-inline__button-group');
    buttonGroups.forEach(buttonGroup => {
      const activeButton = buttonGroup.querySelector('.mobile-facets-inline__button--active');
      if (activeButton && activeButton.dataset.value !== '') {
        const filterParam = activeButton.dataset.filterParam;
        const value = activeButton.dataset.value;
        formData.append(filterParam, value);
      }
    });

    // 收集价格范围值
    const priceInputs = document.querySelectorAll('.mobile-facets-inline__price-input');
    priceInputs.forEach(input => {
      if (input.value) {
        formData.append(input.name, input.value);
      }
    });

    // 构建查询参数
    const searchParams = new URLSearchParams(formData).toString();
    
    // 应用筛选
    if (searchParams) {
      this.onSubmitForm(searchParams, null);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // 重新设置手机端内联筛选器事件监听器
    FacetFiltersForm.setupMobileInlineFiltersAfterRender();
  }

  static setupMobileInlineFiltersAfterRender() {
    // 重新绑定手机端内联筛选器事件监听器
    const facetForm = document.querySelector('facet-filters-form');
    if (facetForm) {
      facetForm.setupMobileInlineFilters();
      facetForm.setupActiveFacetsButtons();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    // 在手机端，同步更新内联筛选器状态
    this.syncInlineFiltersFromURL(url);
    
    FacetFiltersForm.renderPage(url);
  }

  // 新增：根据 URL 参数同步更新内联筛选器
  syncInlineFiltersFromURL(url) {
    if (!url) {
      // 如果 URL 为空，清除所有内联筛选器
      this.clearAllInlineFilters();
      return;
    }

    const urlParams = new URLSearchParams(url);
    
    // 更新 Select 筛选器
    const inlineSelects = document.querySelectorAll('.mobile-facets-inline__select');
    inlineSelects.forEach(select => {
      const paramName = select.name;
      const paramValue = urlParams.get(paramName);
      
      if (paramValue) {
        select.value = paramValue;
      } else {
        select.value = '';
      }
    });

    // 更新 Button Group 筛选器
    const buttonGroups = document.querySelectorAll('.mobile-facets-inline__button-group');
    buttonGroups.forEach(buttonGroup => {
      const buttons = buttonGroup.querySelectorAll('.mobile-facets-inline__button');
      const filterParam = buttons[0]?.dataset.filterParam;
      
      if (filterParam) {
        const paramValue = urlParams.get(filterParam);
        
        // 清除所有按钮的激活状态
        buttons.forEach(button => {
          button.classList.remove('mobile-facets-inline__button--active');
          button.setAttribute('aria-pressed', 'false');
        });

        // 激活对应的按钮
        if (paramValue) {
          buttons.forEach(button => {
            if (button.dataset.value === paramValue) {
              button.classList.add('mobile-facets-inline__button--active');
              button.setAttribute('aria-pressed', 'true');
            }
          });
        }
      }
    });

    // 更新价格范围筛选器
    const priceInputs = document.querySelectorAll('.mobile-facets-inline__price-input');
    priceInputs.forEach(input => {
      const paramName = input.name;
      const paramValue = urlParams.get(paramName);
      
      if (paramValue) {
        input.value = paramValue;
      } else {
        input.value = '';
      }
    });
  }

  // 新增：清除所有内联筛选器
  clearAllInlineFilters() {
    // 清除 Select 筛选器
    const inlineSelects = document.querySelectorAll('.mobile-facets-inline__select');
    inlineSelects.forEach(select => {
      select.value = '';
    });

    // 清除 Button Group 筛选器
    const buttonGroups = document.querySelectorAll('.mobile-facets-inline__button-group');
    buttonGroups.forEach(buttonGroup => {
      const buttons = buttonGroup.querySelectorAll('.mobile-facets-inline__button');
      buttons.forEach(button => {
        button.classList.remove('mobile-facets-inline__button--active');
        button.setAttribute('aria-pressed', 'false');
      });
    });

    // 清除价格范围筛选器
    const priceInputs = document.querySelectorAll('.mobile-facets-inline__price-input');
    priceInputs.forEach(input => {
      input.value = '';
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
